import { ExternalLinkIcon } from 'lucide-react'

import { assets } from '@/ui/assets'
import { DropdownMenuItemIcon } from '@/ui/atoms/dropdown/DropdownMenu'
import { ExternalLink } from '@/ui/atoms/link/Link'
import { MenuItem } from '@/ui/atoms/menu-item/MenuItem'
import { links } from '@/ui/constants/links'

interface TopbarMenuFarmsItemProps {
  closeMenu: () => void
}

export function TopbarMenuFarmsItem({ closeMenu }: TopbarMenuFarmsItemProps) {
  return (
    <MenuItem asChild variant="secondary" className="cursor-pointer rounded-none p-6" withSeparator onClick={closeMenu}>
      <ExternalLink to={links.appSky.farms.all} variant="unstyled">
        <img src={assets.page.farms} alt="Farms icon" className="w-[15px]" />
        Farms
        <DropdownMenuItemIcon icon={ExternalLinkIcon} className="ml-auto" />
      </ExternalLink>
    </MenuItem>
  )
}
